import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { AuthStore } from '@yoshu-lib/core/auth/auth.store'

/**
 * Guard function to restrict access to admin-only routes.
 *
 * This guard checks if the user is logged in and has admin privileges.
 * - If the user is not logged in, they are redirected to the login page.
 * - If the user is logged in but not an admin, they are redirected to the home page.
 * - If the user is an admin, access is granted.
 *
 * @returns `true` if the user is an admin, otherwise `false` after navigation to the appropriate route.
 */
export const adminGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore)
  const router = inject(Router)

  const isAdmin = authStore.isAdmin()
  const isLoggedIn = authStore.isLoggedIn()

  if (isLoggedIn) {
    if (isAdmin) {
      return true
    } else {
      router.navigate(['/'])
      return false
    }
  }

  router.navigate(['/login'])
  return false
}
